import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98e4a47e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<option disabled value=\"\" data-v-98e4a47e>Please select one</option><option value=\"cheerful\" data-v-98e4a47e>Cheerful</option><option value=\"romantic\" data-v-98e4a47e>Romantic</option><option value=\"gloomy\" data-v-98e4a47e>Gloomy</option><option value=\"angry\" data-v-98e4a47e>Angry</option>", 5)
const _hoisted_8 = [
  _hoisted_3
]
const _hoisted_9 = { class: "weather" }

import { ref } from "vue";
import SunnyDay from "./Weather/SunnyDay.vue";
import RomanticDay from "./Weather/RomanticDay.vue";
import GloomyDay from "./Weather/GloomyDay.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserMood',
  setup(__props) {

// İMPORT
const selected = ref(null);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(selected.value)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (selected.value == null)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_2, "How are you today ?"))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("select", {
        name: "sec",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event))
      }, _hoisted_8, 512), [
        [_vModelSelect, selected.value]
      ]),
      _createElementVNode("div", _hoisted_9, [
        (selected.value == 'cheerful')
          ? (_openBlock(), _createBlock(SunnyDay, { key: 0 }))
          : _createCommentVNode("", true),
        (selected.value == 'romantic')
          ? (_openBlock(), _createBlock(RomanticDay, { key: 1 }))
          : _createCommentVNode("", true),
        (selected.value == 'gloomy')
          ? (_openBlock(), _createBlock(GloomyDay, { key: 2 }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})